'use strict';

const $accordionHeader = $('.accordion-heading:not(.pdp-attr-group-title)');
const $accordionSummaryHeader = $('.accordion-heading-wrapper');
const $accordionBody = $('.accordion-body');
/**
 * Accordion Split Module functionality
 */
$(document).ready(function () {
    $accordionHeader.off('click').on('click', function (e) {
        e.preventDefault();
        let $this = $(this);

        if (!$this.hasClass('footer-accordion-header')) {
            if ($this.hasClass('accordion-open')) {
                $this.parent().find($accordionBody).slideUp();
                $this.removeClass('accordion-open');
            } else {
                $accordionBody.slideUp();
                $accordionHeader.removeClass('accordion-open');
                $this.parent().find($accordionBody).slideToggle();
                $this.addClass('accordion-open');
            }
        } else if (!app.checkBreakPoint('lg')) {
            if ($this.hasClass('accordion-open')) {
                $this.parent().find($accordionBody).slideUp();
                $this.removeClass('accordion-open');
            } else {
                $accordionBody.slideUp();
                $accordionHeader.removeClass('accordion-open');
                $this.parent().find($accordionBody).slideToggle();
                $this.addClass('accordion-open');
            }
        }
    });

    $('body')
        .off('click', '.share-wishlist-overlay .accordion-heading')
        .on('click', '.share-wishlist-overlay .accordion-heading', function (e) {
            e.preventDefault();
            let $this = $(this);
            if ($this.hasClass('accordion-open')) {
                $this.parent().find('.accordion-body').slideUp();
                $this.removeClass('accordion-open');
            } else {
                $('.accordion-body').slideUp();
                $('.accordionHeading').removeClass('accordion-open');
                $this.parent().find('.accordion-body').slideToggle();
                $this.addClass('accordion-open');
            }
        });

    $accordionSummaryHeader.off('click').on('click', function (e) {
        e.preventDefault();
        let $this = $(this);
        const $accordionBtn = $this.closest('.accordion').find('.accordion-btn-text');

        if ($accordionBtn.length) {
            const hideText = $accordionBtn.attr('data-hide-text');
            const showText = $accordionBtn.attr('data-show-text');

            if (!$this.hasClass('accordion-open')) {
                $accordionBtn.text(hideText);
            } else {
                $accordionBtn.text(showText);
            }

            const $accordionIcon = $this.find('.summary-btn .icon');
            if ($accordionIcon.length) {
                $accordionIcon.toggleClass('accordion-icon-rotate');
            }
        }

        if ($this.hasClass('accordion-open')) {
            $this.parent().find('.summary-accordion-body').slideUp();
            $this.removeClass('accordion-open');
        } else {
            $accordionBody.slideUp();
            $this.parent().find('.summary-accordion-body').slideToggle();
            $this.addClass('accordion-open');
        }
    });
});
